<script>
import difference from 'lodash.difference'
import { formatISO, subHours } from 'date-fns'

import { words } from '~/common/words.js'

import { getActiveEventCodes } from '~/queries/eventControls'
import { getSingleDeck } from '~/queries/getSingleDeck'
import { saveEventSettings } from '~/queries/saveEventState.gql'
import createEvent from '~/queries/createEvent'
import { findEarlyResponseLimit } from '~/queries/eventQueries.gql'

export default {
  data () {
    return {
      shortcode: '',
      activeEvents: null
    }
  },
  computed: {
    words () {
      return words
    }
  },
  methods: {
    getShortcode (activeRooms, wordlist) {
      const options = difference(wordlist, activeRooms)
      return options[Math.floor(Math.random() * options.length)]
    },
    async startEventById (deckId, options) {
      const { data: deck } = await this.$apollo.query({
        query: getSingleDeck,
        variables: {
          id: deckId
        }
      })

      const { data } = await this.$apollo.query({ query: getActiveEventCodes, fetchPolicy: 'no-cache' })
      this.log('startEventById, active events: ', data)
      const activeRooms = data.activeEventCodes.map(x => x.shortcode)

      this.shortcode = this.getShortcode(activeRooms, words)
      console.log('creating event with shortcode:', this.shortcode)

      const slideDeck = deck.slideDecks[0]
      const event = await this.startEvent(slideDeck, options)

      return event
    },
    async isShortcodeAvailable (shortcode) {
      this.log('checking to see if shortcode is in use: ' + shortcode)
      const { data } = await this.$apollo.query({
        query: getActiveEventCodes,
        fetchPolicy: 'no-cache'
      })

      const activeRooms = data.activeEventCodes.map(x => x.shortcode)

      this.log('current active rooms: ', activeRooms)

      const isAvailable = !activeRooms.includes(shortcode.toLowerCase())

      this.log('is available? ' + isAvailable)
      return isAvailable
    },
    async startEvent (slideDeck, options = {}) {
      this.trackEvent('Start Event')

      const shortcode = this.shortcode.toLowerCase()

      const isShortcodeAvailable = await this.isShortcodeAvailable(shortcode)

      if (!isShortcodeAvailable) {
        this.$buefy.toast.open('That shortcode is in use, try another one')
        return
      }

      const settings = options.settings || {}

      settings.hostPlan = this.$store.getters.userPlan

      if (options.isPreviewEvent) { settings.isPreviewEvent = true }

      // find earliest possible response for performance reasons
      let lowestResponseId
      try {
        const { data: lowResponse } = await this.$apollo.query({ query: findEarlyResponseLimit })
        lowestResponseId = lowResponse.responses[0].id
      } catch (e) { this.log('Error: ', e) }
      settings.lowestResponseId = lowestResponseId || 930000

      const variables = {
        userId: this.$store.state.auth.user.id,
        slideDeckId: slideDeck.id,
        slideDeckCopy: Object.assign({}, slideDeck),
        shortcode,
        settings,
        teamId: this.$store.state.user?.team?.id,
        ...this.getExpiryTimes()
      }

      const { data: newEvent } = await this.$apollo.mutate({
        mutation: createEvent,
        variables
      })

      const eventId = newEvent.insert_events.returning[0].id

      if (settings.useSpectatorEvent) {
        await this.createSpectatorEvent(eventId, variables)
      }

      // const player = { name: 'moderator' }
      // this.$store.commit('setActiveEvent', { id: eventId, shortcode, player })

      this.posthogCapture('event:start', {
        event_id: eventId,
        shortcode,
        deck_id: slideDeck.id,
        deck_name: slideDeck.name
      })

      if (options.stopRedirect === true) {
        return { eventId, shortcode }
      } else {
        this.$router.push('/event/' + shortcode)
      }
    },
    async createSpectatorEvent (eventId, variables) {
      this.log('creating spectator event')
      const spectatorSettings = { ...variables.settings }
      const mainSettings = { ...variables.settings }
      delete variables.settings
      delete variables.shortcode

      const { data: newEvent } = await this.$apollo.mutate({
        mutation: createEvent,
        variables: {
          settings: {
            ...spectatorSettings,
            isSpectatorEvent: true,
            mainEventId: eventId
          },
          ...variables
        }
      })

      const newEventId = newEvent.insert_events.returning[0].id

      // update old event settings with isMainEvent = true and spectatorEventId = ...
      this.log('updating main event settings')
      this.$apollo.mutate({
        mutation: saveEventSettings,
        variables: {
          eventId,
          settings: {
            ...mainSettings,
            isMainEvent: true,
            spectatorEventId: newEventId
          }
        }
      })
    },
    getExpiryTimes () {
      const now = new Date()
      const oneDayAgo = formatISO(subHours(now, 24))

      const val = {
        oneDayAgo
      }

      return val
    }
  }
}
</script>
